<template>
    <div>
        <Tippy
            trigger="mouseenter click"
            animation="scale"
            placement="auto"
        >
            <div class="cursor-pointer rounded-full text-muval-gray-2">
                <SvgIcon
                    name="system-information"
                    class="size-5"
                />
            </div>
            <template #content>
                <div class="relative max-w-sm rounded-muval-2 bg-white px-2 py-1 text-sm shadow-muval-2">
                    <slot name="custom">
                        <p class="font-body text-sm font-normal">{{ text }}</p>
                    </slot>
                </div>
            </template>
        </Tippy>
    </div>
</template>

<script setup>
defineProps({
    text: {
        type: String,
        default: '',
    },
});
</script>
